/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleCount
 */
export interface RoleCount {
    /**
     * 
     * @type {string}
     * @memberof RoleCount
     */
    role: string;
    /**
     * 
     * @type {number}
     * @memberof RoleCount
     */
    count: number;
}

/**
 * Check if a given object implements the RoleCount interface.
 */
export function instanceOfRoleCount(value: object): value is RoleCount {
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function RoleCountFromJSON(json: any): RoleCount {
    return RoleCountFromJSONTyped(json, false);
}

export function RoleCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleCount {
    if (json == null) {
        return json;
    }
    return {
        
        'role': json['role'],
        'count': json['count'],
    };
}

export function RoleCountToJSON(json: any): RoleCount {
    return RoleCountToJSONTyped(json, false);
}

export function RoleCountToJSONTyped(value?: RoleCount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'role': value['role'],
        'count': value['count'],
    };
}

